<template>
    <div>
        <div class="d-flex align-items-center filter-wrapper flex-wrap">
            <div class="form-group">
                <label>Возраст</label>
                <div class="d-flex">
                    <input class="form-control form-age" v-model="currFilters.ageFrom" type="number" min="0" /> 
                    <div class="mx-2 my-1">-</div>
                    <input class="form-control form-age" v-model="currFilters.ageTo" type="number" min="0" /> 
                </div>
            </div>
            <div class="form-group select2">
                <label>Район</label>
                <Select2 :options="districts" :settings="{multiple:true,language:'ru'}" placeholder="(Все)"
                         v-model="currFilters.districtIds"/>
            </div>
            <div class="form-group select2">
                <label>Медицинские организации</label>
                <Select2 :options="organizations" :settings="{multiple:true,language:'ru'}" placeholder="(Все)"
                         v-model="currFilters.organizationIds"/>
            </div>
            <div class="form-group">
                <label>Дата анкетирования</label>
                <div class="d-flex">
                    <date-component v-model="currFilters.dateFrom" class-name="form-date-medium" />
                    <div class="mx-2 my-1">-</div>
                    <date-component v-model="currFilters.dateTo" class-name="form-date-medium" />
                </div>                
            </div>
            <div class="form-group select2">
                <label>Группа риска</label>
                <Select2 :options="risks" :settings="{multiple:true,language:'ru'}" placeholder="(Все)"
                         v-model="currFilters.riskIds"/>
            </div>
            <div class="form-group select2">
                <label>Статус</label>
                <Select2 :options="statuses" :settings="{multiple:true,language:'ru'}" placeholder="(Все)"
                         v-model="currFilters.statusIds"/>
            </div>
        </div>

      <div class="form-group px-0 col-8 select2">
       <div class="d-flex align-items-center">
         <label class="mr-2">Вычислить и отобразить в отчете</label>
         <Checkbox v-model="fieldsChecked"
                   :checked="fieldsChecked"
                   id="fields2"
                   text="Все поля"
         />
       </div>
        <Select2 :options="fields" :settings="{multiple:true,language:'ru'}" placeholder="(Выберите поля)"
                 v-model="currFilters.fields"/>
      </div>
      <div class="form-group px-0 mb-0 col-2">
        <div class="card-footer px-0 d-flex">
          <button-component @click="apply" class="btn-xs">Сформировать</button-component>
          <button-component kind="secondary" class="btn-xs" @click="reset">Сбросить</button-component>
          <button-component kind="success" class="btn-xs" @click="exportReport"><i class="fa fa-download mr-1"></i> Экспорт</button-component>
        </div>
      </div>
    </div>
</template>

<script>
  import ButtonComponent from "../../../common/ui/ButtonComponent";
  import DateComponent from "../../../common/components/DateComponent";
  import NsiApi from "../../admin/api/nsi";
  import OrgApi from "../../organization/api/organizations";
  import Checkbox from "../../../common/ui/checkbox";
  import Api from "../api/withParams";
  export default {
    name: "ReportWithParamsRasFilter",
    components: {Checkbox, ButtonComponent, DateComponent},
    props: {
      filters: Object
    },
    data() {
      return {
        fieldsChecked: true,
        statuses: [],
        risks: [
            {id: 0, text: "Высокий риск", value: 0},
            {id: 1, text: "Средний риск", value: 1},
            {id: 2, text: "Низкий риск", value: 2},
        ],
        districts: [],
        organizations: [],
        fields: [],
        currFilters: this.filters
      }
    },
    created() {
      this.loadDictionaries();
    },
    watch: {
      fieldsChecked: {
        handler(val) {
          console.log(val)
          if(val === true) {
            this.currFilters.fields = this.fields.map(item => item.id)
          }
          if(val === false) {
            this.currFilters.fields = []
          }
        },
        deep: true
      },

    },
    methods: {
      loadDictionaries() {
        NsiApi.getNsi('tmpPatientStatus')
          .then((response) => {
            this.statuses = response.data;
          });
        NsiApi.getNsi('district')
          .then((response) => {
            this.districts = response.data;
          });
        OrgApi.search({pageNumber: 0, pageSize: -1, kindActivityId: 1})
          .then((response) => {
            this.organizations = response.data.items.map(x => ({id: x.id, text: x.name}));
          });
        Api.getPollWithParamsReportFields()
          .then((response) => {
            this.fields = response.data.map((x) => ({id: x.name, text: x.title}));
            this.currFilters.fields = this.fields.map(item => item.id)
          });
      },
      apply() {
        const filters = Object.assign({}, this.currFilters);
        if(filters.male == 1)
            filters.male = null;

        this.$emit('apply', filters);
      },
      reset() {
        this.currFilters = {
          dateFrom: null,
          dateTo: null,
          statusIds: [],
          riskIds: [],
          ageFrom: null,
          ageTo: null,
          districtIds: [],
          organizationIds: [],
          fields: []
        };
        const filters = Object.assign({}, this.currFilters);
        this.$emit('reset', filters);
      },
      exportReport() {
        const filters = Object.assign({}, this.currFilters);
        this.$emit('exportReport', filters);
      }
    }
  }
</script>

<style lang="scss" scoped>
    @import "src/assets/theme/default/colors";

    .form-group {
        label {
            font-weight: 400 !important;
            color: $gray-dark;
            font-size: 16px;
        }
    }
    .filter-wrapper{
        div:not(:last-child){
            margin-right: 16px;
        }
    }
    .card-footer {
        padding-top: 36px;
        gap: 16px;
        align-items: center;
        justify-content: space-between;
    }
    .check-box-group * {
        display: inline-block;
    }
    .form-age {
        max-width: 70px;
    }
</style>